export default "assets/images/bg-programmes-1997ba9a.jpg";